import React from "react";
import { useTranslation } from "react-i18next";
import TrendPanel from "components/common/TrendPanel";
import { formatCash } from "utils/formatCash";
import type { CashFlow } from "./types";

interface SpendVelocityPanelProps {
  cashFlow: CashFlow[];
  loading?: boolean;
}

/** The platform's spend over its trend: the balance card's layout, without the money in and out. */
const SpendVelocityPanel: React.FC<SpendVelocityPanelProps> = ({
  cashFlow,
  loading = false,
}) => {
  const { t } = useTranslation();
  const data = cashFlow?.[0]?.cashFlowData ?? [];
  // An empty code falls back to the formatter's dollars.
  const currency = cashFlow?.[0]?.currency || undefined;
  const total = data.reduce((sum, entry) => sum + (entry.balance ?? 0), 0);

  return (
    <TrendPanel
      title={t("Spend Velocity")}
      value={formatCash(total, currency) ?? ""}
      caption={t("SpendVelocityDescription")}
      series={data.map((entry) => ({ date: entry.date, value: entry.balance }))}
      formatValue={(value) => formatCash(value, currency) ?? ""}
      loading={loading}
    />
  );
};

export default SpendVelocityPanel;
